<div class="modal-header">
    <h4 class="modal-title">Miscellaneous Line</h4>
</div>
<div class="modal-body" (keyup.esc)="close()" (keyup.enter)="save()">
    <dx-form [formData]="orderLine" validationGroup="miscValidationGroup">
        <dxi-item dataField="partNumber" [label]="{ text: 'Part #' }"></dxi-item>
        <dxi-item [label]="{ text: 'Description' }">
            <div *dxTemplate>
                <dx-text-area [(value)]="orderLine.description" [height]="100"> </dx-text-area>
            </div>
        </dxi-item>
        <dxi-item dataField="quantity" editorType="dxNumberBox" [editorOptions]="{ step: 0, width: '150px' }">
            <dxi-validation-rule type="required"> </dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="price" editorType="dxNumberBox" [editorOptions]="{ step: 0, format: { type: 'currency', precision: 2 }, width: '150px' }"> </dxi-item>
        <dxi-item *ngIf="isWarranty" dataField="cost" editorType="dxNumberBox" [editorOptions]="{ step: 0, format: { type: 'currency', precision: 2 }, width: '150px' }">
            <dxi-validation-rule type="required"> </dxi-validation-rule>
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button class="btn btn-primary" (click)="save()">Save</button>
    <button class="btn btn-light" (click)="close()">Cancel</button>
</div>
